module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.601db4d.woff2";